/**
 * Created by orion on 09.05.17.
 */

import angular from 'angular';
import ngTouch from 'angular-touch';

// mainFilters
import main_filters from '../shared/filters/filters_module';


import search_input from '../shared/inputs/search_input/search_input_module';
import preload from '../preload/preload';
//shared modules
import simplePopups from '../shared/simple_popups/simple_popup_module';
import notifications from '../shared/notifications/notifications_module';
import infiniteScroll from '../shared/infiniteScroll_directive';
import selectFactory from '../shared/select_factory/selectFactory_module';
import CurrentUser from '../shared/CurrentUser';
import stuff_previews from '../shared/stuff_preview_directives/stuff_preview_module';
import backUrlGenerator from '../shared/utils/back_url_generator';


//app modules
import add_media from '../add_media/add_media_module';
import view_media from '../view_media/view_media_module';


import attachments from '../shared/attachments/attachments_module';
//pages
import NewGoalsController from '../goals/mainPage/NewGoalsController';
//resources
import GoalsListResource from "./project_list_resource";
import GoalResource from './project_resource';
import GoalTaskResource from './project_task_resource';
import AttachmentsResourceFactory from '../shared/attachments/attachments_resource_factory';
import TasksListResource from "./tasks_list_resource";
//directives

//factories
import linkToGoalFactory from './linkToGoalFactory';
import goalTaskFactory from './GoalDetailPage/goal_tasks/goal_task_options/goal_task_factory';

import LikeStoryResourceFactory from '../shared/story/resource_factory';
import CommentsInfiniteScrollResourceFactory from "../shared/comments/resource_infinite_scroll_factory";
import GoalTaskTagsResource from "./project_task_tags_resource";
import goalSettingsFactory from "./goal_settings_factory/goalSettingsFactory.js";
import GoalTaskDetailResource from "./task_detail_resource";




angular.module('mmApp-projects',
    [backUrlGenerator, ngTouch, 'ui.bootstrap',
        preload, simplePopups, stuff_previews, notifications, add_media, view_media, main_filters, search_input, infiniteScroll, selectFactory, attachments, CurrentUser])
    .controller('NewGoalsController', NewGoalsController)

    .factory('ActionComments', CommentsInfiniteScrollResourceFactory('task_comments'))
    .factory('GoalResource', GoalResource)
    .factory('GoalsListResource', GoalsListResource)
    .factory('GoalTaskResource', GoalTaskResource)
    .factory('GoalTaskTagsResource', GoalTaskTagsResource)
    .factory('TasksListResource', TasksListResource)
    .factory('GoalTaskDetailResource', GoalTaskDetailResource)
    .factory('GoalAttachmentsResource', AttachmentsResourceFactory('goal_attachments'))
    .factory('TaskAttachmentsResource', AttachmentsResourceFactory('task_attachments'))
    .factory('GoalStoryResource', LikeStoryResourceFactory('goal_story'))
    .factory('goalTaskFactory', goalTaskFactory)
    .factory('linkToGoalFactory', linkToGoalFactory)
    .factory('goalSettingsFactory', goalSettingsFactory)
;


export default 'mmApp-projects';
